import { jsx as e } from "react/jsx-runtime";
import { FlexContainer as i } from "./index.es525.js";
import { SimpleTooltip as p } from "./index.es120.js";
import { Icon as m } from "./index.es147.js";
const l = "more-info", g = ({
  tooltip: o,
  testId: t = l,
  tabIndex: r = 0,
  ...n
}) => /* @__PURE__ */ e(i, { alignItems: "center", justifyContent: "center", testId: t, aria: n, children: /* @__PURE__ */ e(p, { ...typeof o == "string" ? { title: o, placement: "right" } : o, testId: `${t}-tooltip`, children: /* @__PURE__ */ e(
  m,
  {
    type: "Info",
    allowHoverState: !0,
    size: 16,
    tabIndex: r,
    weight: "duotone",
    testId: `${t}-icon`
  }
) }) });
export {
  l as MORE_INFO_BASE_TEST_ID,
  g as MoreInfo
};
//# sourceMappingURL=index.es149.js.map
